module.exports = __webpack_public_path__ + "img/basil_edit-outline.96528990.svg";